import React from "react";
import { NakiMobileHomeSectionListTemplate } from "themes/administration/naki-mobile/pages";
import { NakiMobileHandheldHomeSectionListViewStore } from "administration/naki-mobile/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiMobileHandheldHomeSectionListViewStore(rootStore, componentProps),
    "nakiMobileHomeSectionListViewStore"
)
class NakiMobileHandheldHomeSectionList extends React.Component {
    render() {
        return <NakiMobileHomeSectionListTemplate {...this.props} />;
    }
}

export default NakiMobileHandheldHomeSectionList;
